import isEqual from 'lodash/isEqual';
import { QuestionnaireEntities, QuestionnaireFormElement } from '../../questionnaireTemplate.types';

/** Keys that are UI/structural and should never trigger isEdited */
const EDIT_EXCLUDED_KEYS = new Set<keyof QuestionnaireFormElement>([
  'id',
  'expanded',
  'activeBranches',
  'parentId',
  'parentBranch',
]);

/**
 * Returns a new entities object with isEdited stamped on each element
 * that differs from its snapshot counterpart.
 * Returns entities unchanged if no snapshot (CREATE / COPY mode).
 */
export const getEntitiesWithEditedFlag = (
  entities: QuestionnaireEntities,
  snapshotEntities: QuestionnaireEntities | null,
): QuestionnaireEntities => {
  if (snapshotEntities === null) return entities;

  const updatedElements = Object.fromEntries(
    Object.entries(entities.elements).map(([id, element]) => {
      const original = snapshotEntities.elements[id];

      // New element added during edit — not an edit
      if (!original) return [id, element];

      const isEdited = (Object.keys(element) as Array<keyof QuestionnaireFormElement>).some(
        (key) => !EDIT_EXCLUDED_KEYS.has(key) && !isEqual(element[key], original[key]),
      );

      return [id, isEdited ? { ...element, isEdited: true } : element];
    }),
  );

  return { elements: updatedElements };
};
